import * as React from 'react'

import { Box, Card, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import {
  getScore,
  getScoreDescription,
  getScoreRange,
} from 'modules/engagement/lib/netPromoterScore'
import 'modules/enps/pages/AnalyticsPage/index.styles.css'

import { useAnalytics } from '../useAnalytics'

const ScoreNumber = () => {
  const { answeredResultsCount, promoters, detractors } = useAnalytics()

  const score = getScore(promoters, detractors, answeredResultsCount)
  const scoreDescription = getScoreDescription(getScoreRange(score))

  return (
    <Card>
      <Card.Title>{i18n.t('enps.analytics.score.title')}</Card.Title>
      <Card.Content>
        <Box width="full" height="full" gap="s24" justifyContent="center" alignItems="center">
          <Text.Header1 className={'AnalyticsPage_score'}>{score}</Text.Header1>
          <Box height="s32">
            <Text.Normal>{scoreDescription}</Text.Normal>
          </Box>
        </Box>
      </Card.Content>
    </Card>
  )
}
export default observer(ScoreNumber)
